'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserThumbnail = function (_React$PureComponent) {
  _inherits(UserThumbnail, _React$PureComponent);

  function UserThumbnail() {
    _classCallCheck(this, UserThumbnail);

    return _possibleConstructorReturn(this, (UserThumbnail.__proto__ || Object.getPrototypeOf(UserThumbnail)).apply(this, arguments));
  }

  _createClass(UserThumbnail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color;

      return _react2.default.createElement(
        'svg',
        { width: size, height: size, viewBox: '0 0 44 44' },
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { fill: color },
            _react2.default.createElement('path', { d: 'M29.5180179,34.6171139 L14.512649,34.6171139 C13.487687,34.6171139 10.8433025,29.7727343 11.0072965,28.594028 C11.1712904,27.4153217 11.9623156,24.6205101 12.7105379,24.0157825 C13.4587601,23.4110549 15.3633575,22.1521739 16.511315,22.1521739 C17.2287884,22.8286488 18.0538704,23.3718706 18.9865859,23.7818554 C19.9193013,24.1918402 20.9288737,24.3968295 22.0153335,24.3968295 C23.081294,24.3968295 24.0857417,24.1918402 25.0287067,23.7818554 C25.9716718,23.3718706 26.8018786,22.8286488 27.519352,22.1521739 C28.6673095,22.1521739 30.5667821,23.4110549 31.3047548,24.0157825 C32.0427274,24.6205101 32.8286279,27.4153217 32.9926218,28.594028 C33.1566157,29.7727343 30.54298,34.6171139 29.5180179,34.6171139 Z M28.9347826,15.9505794 C28.9347826,16.8983904 28.7557543,17.7935318 28.3976924,18.6360305 C28.0396304,19.4785292 27.5446699,20.2157045 26.9127959,20.8475785 C26.2809219,21.4794525 25.5437466,21.9744131 24.7012479,22.332475 C23.8587492,22.6905369 22.9636078,22.8695652 22.0157968,22.8695652 C21.0469233,22.8695652 20.1412508,22.6905369 19.2987521,22.332475 C18.4562534,21.9744131 17.7243437,21.4794525 17.1030009,20.8475785 C16.4816581,20.2157045 15.9866976,19.4785292 15.6181044,18.6360305 C15.2495112,17.7935318 15.0652174,16.8983904 15.0652174,15.9505794 C15.0652174,14.9817059 15.2495112,14.0760334 15.6181044,13.2335347 C15.9866976,12.391036 16.4816581,11.6591263 17.1030009,11.0377835 C17.7243437,10.4164407 18.4562534,9.92148017 19.2987521,9.552887 C20.1412508,9.18429382 21.0469233,9 22.0157968,9 C22.9636078,9 23.8587492,9.18429382 24.7012479,9.552887 C25.5437466,9.92148017 26.2809219,10.4164407 26.9127959,11.0377835 C27.5446699,11.6591263 28.0396304,12.391036 28.3976924,13.2335347 C28.7557543,14.0760334 28.9347826,14.9817059 28.9347826,15.9505794 Z' })
          )
        )
      );
    }
  }]);

  return UserThumbnail;
}(_react2.default.PureComponent);

UserThumbnail.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

UserThumbnail.defaultProps = {
  size: 44,
  color: '#FFF'
};

exports.default = UserThumbnail;